import './imports';
import jQuery from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import configureStore from './store/configureStore';
import Root from './containers/Root';
import { switchBreakpoints } from './Breakpoints/breakpoints.actions';

jQuery.cookie('to_force_inclusion_in_code');

const store = configureStore();
const root = document.getElementById('root');

window.addEventListener(
    'rpBreakpointsSwitch',
    e => store.dispatch(switchBreakpoints(e.detail))
);

ReactDOM.render(
    <AppContainer>
        <Root store={store} />
    </AppContainer>,
    root
);

if (module.hot) {
    module.hot.accept('./containers/Root', () => {
        // If you use Webpack 2 in ES modules mode, you can
        // use <App /> here rather than require() a <NextApp />.
        // eslint-disable-next-line
        const NextApp = require('./containers/Root').default;
        ReactDOM.unmountComponentAtNode(root);
        ReactDOM.render(
            <AppContainer>
                <NextApp store={store} />
            </AppContainer>,
            root
        );
    });
}



// WEBPACK FOOTER //
// ./src/js/index.js